import React, {Component} from 'react';
import {Logo, HeaderNavigation} from '..';

import styles from './styles';

// Note: if this uses PureComponent, the active links in the header stop working
export default class Header extends Component {

  render() {
    return (
      <div className={styles.header}>
        <Logo className={styles.logo} />
        <HeaderNavigation />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/index.jsx